import axios from "axios";
import { Buffer } from "buffer";
import { jwtDecode } from "jwt-decode";

export function getAuthToken() {
  return localStorage.getItem("authToken");
}

export function infomacesToken() {
  const token = getAuthToken();
  return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
}

export function getRole() {
  const token = localStorage.getItem("authToken");

  if (!token) {
    console.warn("Nenhum token encontrado no localStorage");
    return null;
  }

  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch (err) {
    console.error(`Erro ao decodificar o token: ${err}`);
    return null;
  }
}

const api = axios.create({
 baseURL: "https://conexao-literaria.institutoyoux.org.br/api",
});

// const api = axios.create({
//   baseURL: "http://localhost:8080/api",
// });

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject("Erro na api", error);
  }
);

export function autenticar() {
  return api.get("/autenticar");
}

export function logando(objetoLogin) {
  return api.post("/autenticar/login", objetoLogin);
}

export function buscarLivros(limite, pagina, filtro) {
  return api.post(`/livro/buscaLivro/${limite}/${pagina}`, filtro);
}

export function buscarGeneros() {
  return api.get("/generos");
}

export function buscarEmprestimos(objEmprestimo) {
  return api.post("/emprestimo/buscaEmprestimo", objEmprestimo);
}

export function renovandoEmprestimos(objRenovando) {
  return api.post("/emprestimo/renovarEmprestimo", objRenovando);
}

export function buscarAlunos(objFiltro) {
  return api.post("/aluno/buscaAluno", objFiltro);
}

export function getDadosLivroIsbnOpenLibrary(isbn) {
  return axios.get(
    `https://openlibrary.org/api/books?bibkeys=ISBN:${isbn}&jscmd=details&format=json`
  );
}

export function getDadosLivroIsbnGoogle(isbn) {
  return axios.get(
    `https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}`
  );
}

export function cadastrarAluno(alunoNovo) {
  return api.post("/aluno/registrarAluno", alunoNovo);
}

export function editarAluno(aluno) {
  return api.put("/aluno/editarDadosAluno", aluno);
}

export function devolvendoLivros(objDevolvendo) {
  return api.post("/emprestimo/devolverLivro", objDevolvendo);
}

export function buscarAlunosporId(id) {
  return api.get(`/aluno/informacaoAluno/${id}`);
}

export function buscarTodosAlunos() {
  return api.get("/aluno");
}

export function efetuandoEmprestimo(objEmprestando) {
  return api.post("/emprestimo/emprestarLivro", objEmprestando);
}

export function enviarEmailRedefinirSenha(email) {
  return api.post("/email/esqueciMinhaSenha", email);
}

export function recuperarSenha(dados) {
  return api.post("/autenticar/recuperarSenha", dados);
}

export function cadastrarLivro(objCadastrando) {
  return api.post("/livro/registrarLivro", objCadastrando);
}

export function buscandoInfoLivro(id) {
  return api.get(`/livro/informacaoLivro/${id}`);
}

export function emprestimoLivro(id, limit, page) {
  return api.get(`/livro/listaEmprestimoLivro/${id}/${limit}/${page}`);
}

export function salvandoEditar(dadoEditarLivro) {
  return api.put("/livro/editarLivro", dadoEditarLivro);
}

export async function pegarListaRanking () {
  const response = await api.get("/ranking")
  return response.data
}

export function salvarAvaliacao(dados) {
  return api.post("/avaliacao/salvarAvaliacao", dados)
}

export function emprestimoAluno(objEmprestimoAluno) {
  return api.post("/emprestimo/livrosEmprestados", objEmprestimoAluno)
}

export function historicoAluno(objHistoricoAluno) {
  return api.post("/emprestimo/historicoEmprestimo", objHistoricoAluno)
}

export function buscarTopLivros() {
  return api.get("/livro/topLivrosMaisBemAvaliados")
}

export function InfoLivroTelaInicial(objTelaInicial) {
  return api.post("/livro/telaInicial" , objTelaInicial)
}

export async function mandarSenha(hash, senha) {
    api.post(`/autenticar/primeiraSenhaAluno/${hash}`, {
      senha: senha
    })
}

export async function favoritarLivro(idLivro) {
  return api.post(`/livroFavorito/favoritar/${idLivro}`)
}

export function buscarperfil(idAluno) {
  return api.get(`/aluno/perfilAluno/${idAluno}`);
}

export function atualizarAvatar(dados) {
  return api.put("/aluno/atualizarAvatar", dados)
}

export function notificarLivroDisponivel(idLivro) {
  return api.get(`/livro/notificarDisponivel/${idLivro}`)
}
